import { render, staticRenderFns } from "./addfooterDisposition.vue?vue&type=template&id=9a5d32f8&scoped=true&"
import script from "./addfooterDisposition.vue?vue&type=script&lang=js&"
export * from "./addfooterDisposition.vue?vue&type=script&lang=js&"
import style0 from "./addfooterDisposition.vue?vue&type=style&index=0&id=9a5d32f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5d32f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5d32f8')) {
      api.createRecord('9a5d32f8', component.options)
    } else {
      api.reload('9a5d32f8', component.options)
    }
    module.hot.accept("./addfooterDisposition.vue?vue&type=template&id=9a5d32f8&scoped=true&", function () {
      api.rerender('9a5d32f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addfooterDisposition.vue"
export default component.exports